import { render, staticRenderFns } from "./expensePermissions.vue?vue&type=template&id=36f4ac3c"
import script from "./expensePermissions.vue?vue&type=script&lang=js"
export * from "./expensePermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports